<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-shopping-cart"></i> Orders
      </Tab>
      <Tab tabid="tab-2">
        <i class="far fa-database"></i> Order Recovery
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <OrderDataTable ref="orderDataTable" :useQueryData="true">
          <template v-slot:title>
            <h3>Order List</h3>
          </template>
          <template v-slot:tools>
            <button class="btn btn-white mr-2" v-if="false"> <i class="far fa-search"></i> Search</button>
            <ActionButton type="scan" v-if="userHasUpdatePermission(PermissionTypes.OrderPermissionTypes.orderAccountsApproval)" class="mr-2" @click="showScanOrders"> Scan Orders</ActionButton>
            <LinkButton type="new" href="/orders/new" v-if="userHasCreatePermission(PermissionTypes.OrderPermissionTypes.order)" sizeClass="btn"> New Order</LinkButton>
          </template>
        </OrderDataTable>

      </TabPage>

      <TabPage tabid="tab-2">

        <OrderRecoveryDataTable ref="orderRecoveryDataTable">
          <template v-slot:title>
            <ContentTitle>Order Recovery List</ContentTitle>
            <ContentSubTitle>Larger orders started in the editor are auto saved for recovery in the case of issues during order creation</ContentSubTitle>
          </template>
        </OrderRecoveryDataTable>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import ScanOrdersDialog from '@/modules/orders/views/scanOrdersDialog'

import OrderDataTable from '@/modules/orders/components/orderDataTable'
import OrderRecoveryDataTable from '@/modules/orders/components/orderRecoveryDataTable'

export default {
  name: "OrderList",
  components: {
    OrderDataTable,
    OrderRecoveryDataTable
  },
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title
    }
  },
  mounted() {

  },
  methods: {
    createOrder() {
      this.$router.push('/orders/new')
    },
    createQuote() {
      this.$router.push('/orders/new?type=quote')
    },
    showScanOrders() {
      this.displayModal(ScanOrdersDialog)
      .then((success) => {
        if(success) {
          this.successToast('Orders Processed')
          this.$refs.orderDataTable.reload()
        }
      })
    }
  }
};
</script>
